import React from "react";
import { CLOSING_CTA } from "../shared/ctaContent.js";

const QuietClosingCta = ({ onOpenModal, onOpenDemoModal }) => (
  <section
    className="cursor-section cursor-closing-cta-section roofing-closing-cta"
    data-testid="quiet-closing-cta"
  >
    <div className="cursor-closing-cta-inner">
      <h2 className="cursor-closing-cta-headline">
        {CLOSING_CTA.headlineLead}{" "}
        <span className="roofing-closing-cta-gain">{CLOSING_CTA.headlineGain}</span>{" "}
        {CLOSING_CTA.headlineMid}{" "}
        <span className="cursor-closing-cta-headline-accent">{CLOSING_CTA.headlineAccent}</span>
      </h2>
      <p className="cursor-closing-cta-subhead">{CLOSING_CTA.subheadline}</p>
      <div className="cursor-closing-cta-shell">
        <button
          type="button"
          className="quiet-cta quiet-cta-primary"
          onClick={onOpenModal}
          data-testid="quiet-closing-cta-button"
        >
          <span>{CLOSING_CTA.buttonLabel}</span>
          <span className="quiet-cta-arrow" aria-hidden="true">
            ↗
          </span>
        </button>
        <div className="cursor-cta-caption-block" data-testid="quiet-closing-cta-disclosure">
          <p className="cursor-cta-caption">{CLOSING_CTA.disclosure}</p>
        </div>
        <p className="roofing-closing-demo-prompt">{CLOSING_CTA.demoPrompt}</p>
        <button
          type="button"
          className="roofing-closing-demo"
          onClick={onOpenDemoModal}
          data-testid="quiet-closing-demo-button"
        >
          <span>{CLOSING_CTA.demoLabel}</span>
          <span aria-hidden="true"> ↗</span>
        </button>
      </div>
    </div>
  </section>
);

export default QuietClosingCta;
